// @bend-expect ban-forbidden-imports
import { ErrorBoundary as _ErrorBoundary } from 'fail-safe/ErrorBoundary';
// @bend-expect ban-forbidden-imports

class _ErrorBoundaryWithCallerPackage extends _ErrorBoundary {
  get failSafeCallerPackage() {
    return 'marketplace-embed';
  }
}
export { _ErrorBoundaryWithCallerPackage as ErrorBoundary };